import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import request from "../../api/request";
import { toast } from "react-hot-toast";
import axios from "axios";
// DatePicker imports removed - using UnifiedDatePicker component instead


export const saveTeamsDayAction = createAsyncThunk(
  "main/saveTeamsDay",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/teams_daystbl/${token}/`,
        data
      );
      toast.success(response.data.message || "تم حفظ يوم العطلة بنجاح");
      return response.data;
    } catch (error) {
      toast.error("فشل الحفظ");
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTarweesData = createAsyncThunk(
  "main/fetchTarweesData",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.get(`/api/alfares/fetchTarwees/${token}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const isValidDate = (date) => {
  return !isNaN(Date.parse(date));
};

export const updateSchoolStatus = createAsyncThunk(
  "main/updateSchoolStatus",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const url = `/api/alfares/schools/updateStatus/${data.rgmw}/${data.status}/${token}`;
      console.log(`🌐 API POST Request -> ${url}`);
      const response = await request.post(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const resetSingleSchoolStatus = createAsyncThunk(
  "main/resetSingleSchoolStatus",
  async (rgmw, { getState, rejectWithValue }) => {
    try {
      let token = getState().main.token;
      if (!token) {
        const credentials = JSON.parse(localStorage.getItem("userCredentials"));
        token = credentials?.token;
      }

      if (!token) {
        return rejectWithValue("Missing token");
      }

      const url = `/api/alfares/schools/resetSingleSchoolStatus/${rgmw}/${token}`;
      const response = await request.post(url);
      return { rgmw, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const resetOldConnectionsStatus = createAsyncThunk(
  "main/resetOldConnectionsStatus",
  async (_, { getState, rejectWithValue }) => {
    try {
      let token = getState().main.token;
      if (!token) {
        const credentials = JSON.parse(localStorage.getItem("userCredentials"));
        token = credentials?.token;
      }

      if (!token) {
        return rejectWithValue("Missing token");
      }

      const url = `/api/alfares/schools/resetOldConnectionsStatus/${token}`;
      const response = await request.post(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editVersion = createAsyncThunk(
  "main/editVersion",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      // 🟢 للتأكد من التوكن
      //console.log("🔑 Token from Redux state:", token);

      if (!isValidDate(data.date) || !isValidDate(data.date2)) {
        throw new RangeError("Invalid date value");
      }

      if (!token) {
        throw new Error("Missing token in editVersion");
      }

      // Ensure backend-friendly date format (YYYY-MM-DD)
      const formatDateOnly = (value) => {
        const d = new Date(value);
        return isNaN(d.getTime()) ? "" : d.toISOString().split("T")[0];
      };

      const payload = {
        number: data.number,
        date: formatDateOnly(data.date),
        text: data.text,
        date2: formatDateOnly(data.date2),
        only64: Number(data.only64) || 0,
        school_year: data.school_year,
        gemini_model: data.gemini_model,
      };

      const response = await request.post(
        `/api/alfares/versions/${token}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      console.error("Error in editVersion:", error);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


export const updateSchoolPayDate = createAsyncThunk(
  "main/updateSchoolPayDate",
  async ({ rgmw, date }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/${rgmw}/updateDate/${date}/${token}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// تمديد جماعي: إضافة أيام على تاريخ الاشتراك للمدارس المحددة
export const extendSchoolsBulk = createAsyncThunk(
  "main/extendSchoolsBulk",
  async ({ schools, days }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/extend-bulk/${token}`,
        { schools, days }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const deleteSchool = createAsyncThunk(
  "main/deleteSchool",
  async (rgmw, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.delete(
        `/api/alfares/schools/${rgmw}/${token}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteExpense = createAsyncThunk(
  "main/deleteExpense",
  async (id, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.delete(
        `/api/alfares/expenses/${id}/${token}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const changeStatusSchool = createAsyncThunk(
  "main/changeStatusSchool",
  async (rgmw, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/changeStatus/${rgmw}/${token}/`
      );
      // بدون toast هنا — الرسالة تظهر من مكان الاستدعاء فقط
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateSchoolNote = createAsyncThunk(
  "main/updateSchoolNote",
  async ({ rgmw, noteforschool }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/updateNote/${rgmw}/${token}`,
        { noteforschool }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const changeAiUsageSchool = createAsyncThunk(
  "main/changeAiUsageSchool",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-ai-usage/${token}`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateStopAiAction = createAsyncThunk(
  "main/updateStopAi",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-stop-ai/${token}`,
        data
      );
      toast.success(
        response.data.message || "تم تحديث حالة الذكاء الصناعي بنجاح"
      );
      return response.data;
    } catch (error) {
      console.error("Error in updateStopAiAction:", error);
      const msg =
        error.response?.data?.message || "فشل في تحديث حالة الذكاء الصناعي";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);


export const updateSchoolApiGroup = createAsyncThunk(
  "main/updateSchoolApiGroup",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-api-group/${token}`,
        data
      );
      toast.success(response.data.message || "تم تحديث مجموعة جيميل بنجاح");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const changeSchoolClosed = createAsyncThunk(
  "main/changeSchoolClosed",
  async (rgmw, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/changeClosedStatus/${rgmw}/${token}/`
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SeenNote = createAsyncThunk(
  "main/SeenNote",
  async (id, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.delete(
        `/api/alfares/notes/${id}/${token}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const MakeNote = createAsyncThunk(
  "main/MakeNote",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/notes/${token}/`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchoolPhoneNumber = createAsyncThunk(
  "main/updateSchoolPhoneNumber",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/phone/${data.rgmw}/${data.phone}/${token}/`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchoolPSEditPin = createAsyncThunk(
  "main/updateSchoolPSEditPin",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/psedit/${data.rgmw}/${data.psPin}/${token}/`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchoolAnydeskId = createAsyncThunk(
  "main/updateSchoolAnydeskId",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/anydesk/${data.rgmw}/${data.anydeskid}/${token}/`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCanAddStore = createAsyncThunk(
  "main/updateCanAddStore",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-can-add-store/${token}/`,
        data
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchoolName = createAsyncThunk(
  "main/updateSchoolName",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/name/${data.rgmw}/${data.name}/${token}/`,
        data
      );
      toast.success(response.data.message || "تم تحديث اسم المدرسة بنجاح");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddSchool = createAsyncThunk(
  "main/AddSchool",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.put(`/api/alfares/schools/${token}/`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      console.error("AddSchool error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "فشل إضافة المدرسة");
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const AddFinancial = createAsyncThunk(
  "main/AddFinancial",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      // Validation
      if (!token) {
        throw new Error("لا يوجد رمز مصادقة");
      }

      if (!data.rgmw) {
        throw new Error("رقم المدرسة مطلوب");
      }

      if (data.price === undefined || data.price === null || data.price < 0) {
        throw new Error("المبلغ يجب أن يكون أكبر من أو يساوي صفر");
      }

      const response = await request.post(
        `/api/alfares/schools/setPrice/${token}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const AddExpense = createAsyncThunk(
  "main/AddExpense",
  async (data, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/schools/expenses/${data.name}/${data.price}/${token}/`
      );
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateEmployee = createAsyncThunk(
  "main/updateEmployee",
  async ({ emp_id, data }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.put(
        `/api/alfares/updateEmployee/${emp_id}/${token}/`,
        data
      );
      toast.success(response.data.message || "تم حفظ التعديلات بنجاح");
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message || "فشل في حفظ التعديلات");
      return rejectWithValue(error.message);
    }
  }
);

export const fetchData = createAsyncThunk(
  "main/fetchData",
  async (force = false, { getState, rejectWithValue }) => {
    const state = getState();

    if (!force) {
      const missing =
        !state.main.data?.schoolData ||
        !state.main.data?.allteachers ||
        !state.main.data?.holidaysData ||
        !state.main.data?.tasksDaysData ||
        !state.main.data?.anwa3wathtbl ||
        !state.main.data?.whatsNewData ||
        !state.main.data?.transferredTeachersData;

      if (!missing) {
        return { data: state.main.data };
      }
    }

    // غير هيك، روح جيبها من السيرفر
    const credentials = JSON.parse(localStorage.getItem("userCredentials"));
    const token = credentials?.token;

    if (!token) return rejectWithValue("Missing token");

    try {
      // Each per-module fetch is isolated: a 403 (module not permitted for
      // this role) must not break the whole data load — it just yields [].
      const safeGet = async (url, pick) => {
        try {
          const res = await axios.get(url);
          return pick(res.data);
        } catch (err) {
          if (err?.response?.status !== 403)
            console.error("fetchData module error:", url, err.message);
          return [];
        }
      };

      const mainResponse = await axios.get(
        `https://api.alfares.cloud/api/alfares/fetchData/${token}`
      );
      const [jobs, whatsNewData, transferredTeachersData, alfarestext, eventsData, annualEventsData] =
        await Promise.all([
          safeGet(`https://api.alfares.cloud/api/alfares/fetchJobs`, (d) => d.jobs || []),
          safeGet(
            `https://api.alfares.cloud/api/alfares/whatsnewtbl/${token}`,
            (d) => d?.whatsnew || []
          ),
          safeGet(
            `https://api.alfares.cloud/api/alfares/teachers_tnglat/${token}`,
            (d) => d || []
          ),
          safeGet(
            `https://api.alfares.cloud/api/alfares/schools/notes/${token}`,
            (d) => d || []
          ),
          safeGet(
            `https://api.alfares.cloud/api/alfares/events/${token}`,
            (d) => d || []
          ),
          safeGet(
            `https://api.alfares.cloud/api/alfares/annual-events/${token}`,
            (d) => d || []
          ),
        ]);

      // جلب كل ثوابت المدارس مرة واحدة (مطلوب لصفحات FindTeachers و SchoolDetails)
      let thawabetData = [];
      try {
        const thawabetRes = await axios.get(
          `https://api.alfares.cloud/api/alfares/fetchAllThawabet/${token}`
        );
        thawabetData = thawabetRes.data?.thawabetData ?? [];
      } catch (err) {
        console.error("Thawabet fetch error:", err);
      }

      // جلب بيانات الراغبة في التجديد
      let renewalChoicesData = [];
      try {
        const renewalChoicesRes = await axios.get(
          `https://api.alfares.cloud/api/alfares/school-renewal-choices/${token}`
        );
        renewalChoicesData = renewalChoicesRes.data || [];
      } catch (err) {
        console.error("Renewal choices fetch error:", err);
      }

      return {
        data: {
          ...mainResponse.data.data,
          anwa3wathtbl: jobs,
          whatsNewData,
          transferredTeachersData,
          alfarestext,
          eventsData,
          annualEventsData,
          renewalChoices: renewalChoicesData,
          thawabetData,
        },
      };
    } catch (error) {
      return rejectWithValue("فشل في جلب البيانات");
    }
  }
);

export const setApiKey = createAsyncThunk(
  "main/setApiKey",
  async (apiKey, { getState, rejectWithValue }) => {
    try {
      // Store the API key in the Redux store first
      // In a real application, you might want to validate the API key with a server call here
      // const token = getState().main.token;
      // const response = await request.post(`/api/alfares/set-api-key/${token}/`, { apiKey });

      // For now, we'll just store it locally and consider it successful
      localStorage.setItem("apiKey", apiKey);
      toast.success("تم حفظ مفتاح API بنجاح");
      return { apiKey };
    } catch (error) {
      toast.error("فشل في حفظ مفتاح API");
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchoolPrice = createAsyncThunk(
  "main/updateSchoolPrice",
  async ({ rgmw, price, pay_date }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      // Validation
      if (!token) {
        throw new Error("لا يوجد رمز مصادقة");
      }

      if (!rgmw) {
        throw new Error("رقم المدرسة مطلوب");
      }

      if (price === undefined || price === null || price < 0) {
        throw new Error("المبلغ يجب أن يكون أكبر من أو يساوي صفر");
      }

      const payload = { rgmw, price };
      if (pay_date) payload.pay_date = pay_date;

      const response = await request.post(
        `/api/alfares/schools/setPrice/${token}`,
        payload
      );
      return { rgmw, price, pay_date, data: response.data };
    } catch (error) {
      toast.error(error.response?.data?.message || "فشل تحديث سعر المدرسة");
      return rejectWithValue(error.message);
    }
  }
);

export const updateSchoolPaymentType = createAsyncThunk(
  "main/updateSchoolPaymentType",
  async ({ rgmw, payment_type }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;

      if (!token) {
        throw new Error("لا يوجد رمز مصادقة");
      }

      if (!rgmw) {
        throw new Error("رقم المدرسة مطلوب");
      }

      const validTypes = ["full", "discounted", "donation", "prepaid"];
      if (!validTypes.includes(payment_type)) {
        throw new Error("نوع الدفع غير صالح");
      }

      const response = await request.post(
        `/api/alfares/schools/paymentType/${token}`,
        {
          rgmw,
          payment_type,
        }
      );
      toast.success(response.data.message || "تم تحديث نوع الدفع بنجاح");
      return { rgmw, payment_type, data: response.data };
    } catch (error) {
      toast.error(error.response?.data?.message || "فشل تحديث نوع الدفع");
      return rejectWithValue(error.message);
    }
  }
);



// Slice
export const mainSlice = createSlice({
  name: "main",
  initialState: {
    auth: {},
    user: null,
    permissions: null,
    isFinanceLogged: false,
    error: null,
    apiKey: localStorage.getItem("apiKey") || "",
    data: {},
    tarweesData: [],
    holidaysData: [],
    tasksDaysData: [],
    loading: false, // إضافة حالة loading
  },

  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.auth = action.payload.data;
      state.user = action.payload.user || null;
      state.permissions = action.payload.permissions || null;
      const userData = {
        token: action.payload.token,
        auth: action.payload.data,
        user: action.payload.user || null,
        permissions: action.payload.permissions || null,
      };

      // Save user data in local storage
      localStorage.setItem("userCredentials", JSON.stringify(userData));

      state.error = null;
    },
    saveDataLocalStorage: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.auth = action.payload.auth;
      state.user = action.payload.user || null;
      state.permissions = action.payload.permissions || null;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
    },
    loginFinance: (state, action) => {
      state.isFinanceLogged = true;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.auth = null;
      state.user = null;
      state.permissions = null;
      state.error = null;
      localStorage.removeItem("userCredentials");
    },
    changeStatusOfSchool: (state, action) => {
      const { rgmw, status } = action.payload;
      const school = state.data.schoolData.find(
        (school) => school.rgmw === rgmw
      );
      if (school) {
        school.onoff = status;
      }
    },

    updateSchoolStatusLocal: (state, action) => {
      const { rgmw, newStatus } = action.payload;
      const school = state.data?.schoolData?.find(
        (s) => String(s.rgmw) === String(rgmw)
      );
      if (school) {
        // الواجهة تقرأ school.onoff ("on"/"off") — حدّثه مباشرة ليظهر التغيير فورًا
        school.onoff = newStatus;
        if (newStatus === 0 || newStatus === "off") {
          school.school_status = 0;
        } else if (newStatus === 1 || newStatus === "on") {
          school.school_status = 1;
        }
        // مسح تاريخ التمديد محليًا عند التعطيل
        if (newStatus === "off") {
          school.paydate = null;
        }
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = {
          ...action.payload?.data,
          schoolData: action.payload?.data?.schoolData || [],
          allteachers: action.payload?.data?.allteachers || [],
          holidaysData: action.payload?.data?.holidaysData || [],
          tasksDaysData: action.payload?.data?.tasksDaysData || [],
          anwa3wathtbl: action.payload?.data?.anwa3wathtbl || [],
          phones: action.payload?.data?.phones || [],
          alfaresVersionData: action.payload?.data?.alfaresVersionData || [],
          alfaresNoteData: action.payload?.data?.alfaresNoteData || [],
          expirydateData: action.payload?.data?.expirydateData || [],
          whatsNewData: action.payload?.data?.whatsNewData || [],
          tarweesData: action.payload?.data?.tarweesData || [],
          transferredTeachersData: action.payload?.data?.transferredTeachersData || [],
          eventsData: action.payload?.data?.eventsData || [],
          annualEventsData: action.payload?.data?.annualEventsData || [],
          notificationsData: action.payload?.data?.notificationsData || [],
          anydeskData: action.payload?.data?.anydeskData || [],
        };
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "فشل في جلب البيانات";
        toast.error(state.error);
      });

    builder.addCase(setApiKey.fulfilled, (state, action) => {
      state.apiKey = action.payload.apiKey;
    });

    builder.addCase(fetchTarweesData.fulfilled, (state, action) => {
      state.tarweesData = action.payload.data;
    });

    builder.addCase(updateCloseMaliaAction.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const school = state.data.schoolData.find(
        (school) => school.rgmw === action.payload.rgmw
      );
      if (school) {
        school.close_malia = action.payload.status;
      }
    });

    builder.addCase(updateCloseEmployeeAction.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const school = state.data.schoolData.find(
        (school) => school.rgmw === action.payload.rgmw
      );
      if (school) {
        school.close_employee = action.payload.status;
      }
    });

    builder.addCase(updateCloseStudentsAction.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const school = state.data.schoolData.find(
        (school) => school.rgmw === action.payload.rgmw
      );
      if (school) {
        school.close_students = action.payload.status;
      }
    });

    builder.addCase(updateCloseModeerAction.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const school = state.data.schoolData.find(
        (school) => school.rgmw === action.payload.rgmw
      );
      if (school) {
        school.close_modeer = action.payload.status;
      }
    });

    builder.addCase(updateCanAddStore.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const school = state.data.schoolData.find(
        (school) => school.rgmw === action.meta.arg.rgmw
      );
      if (school) {
        school.can_add_store = action.meta.arg.status;
      }
    });

    builder.addCase(changeAiUsageSchool.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const { rgmw, usage } = action.payload;
      const school = state.data.schoolData.find((s) => s.rgmw === rgmw);
      if (school) {
        school.AI_UsageToday = usage;
      }
    });

    /*builder.addCase(updateStopAiAction.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const { rgmw, stopAi } = action.payload;
      const school = state.data.schoolData.find((s) => s.rgmw === rgmw);
      if (school) {
        school.stop_ai = stopAi;
        console.log("✅ تم تحديث stop_ai محلياً:", { rgmw, stopAi });
      }
    });*/

    builder.addCase(updateSchoolApiGroup.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const { rgmw, apiGroup } = action.payload;
      const school = state.data.schoolData.find((s) => s.rgmw === rgmw);
      if (school) {
        school.api_group = apiGroup;
      }
    });

    builder.addCase(updateSchoolPrice.fulfilled, (state, action) => {
      state.status = "succeeded";
      const { rgmw, price } = action.payload;
      if (state.data && state.data.schoolData) {
        const schoolIndex = state.data.schoolData.findIndex(
          (school) => school.rgmw === rgmw
        );
        if (schoolIndex !== -1) {
          state.data.schoolData[schoolIndex].price = price;
        }
      }
    });

    builder.addCase(updateSchoolPaymentType.fulfilled, (state, action) => {
      const { rgmw, payment_type } = action.payload;
      if (state.data && state.data.schoolData) {
        const school = state.data.schoolData.find((s) => s.rgmw === rgmw);
        if (school) {
          school.payment_type = payment_type;
        }
      }
    });

    builder.addCase(updateSchoolName.fulfilled, (state, action) => {
      if (!state.data?.schoolData) return;
      const { rgmw, name } = action.payload;
      const school = state.data.schoolData.find((s) => s.rgmw === rgmw);
      if (school) {
        school.schoolname = name;
      }
    });

    builder.addCase(deleteExpense.fulfilled, (state, action) => {
      const id = action.meta.arg;
      if (state.data?.expensesData) {
        state.data.expensesData = state.data.expensesData.filter(
          (expense) => expense.id !== id
        );
      }
    });
  },
});

export const {
  saveDataLocalStorage,
  loginSuccess,
  loginFailure,
  logout,
  removeNote,
  changeStatusOfSchool,
  loginFinance,
  setApiKeyLocal,
} = mainSlice.actions;

export const loginAction = (data) => async (dispatch) => {
  const loadingToast = toast.loading("جاري تسجيل الدخول");
  try {
    const response = await request.post("/api/alfares/login", data);
    await dispatch(
      loginSuccess({
        data: response.data.data,
        token: response.data.token,
        user: response.data.user || null,
        permissions: response.data.permissions || null,
      })
    );
    await dispatch(fetchData());
    toast.success(response.data.message, { id: loadingToast });
  } catch (error) {
    toast.error("هناك خطا ما في اسم المستخدم او الباسورد", { id: loadingToast });
    dispatch(loginFailure(error.message));
  }
};

export const saveLogin = (credentials) => async (dispatch) => {
  try {
    // Backward compatibility: sessions stored before the permissions system
    // have only { token, auth } with no user/permissions. Those tokens belong
    // to the legacy shared login, which the backend still honors as super
    // admin — mirror that locally so old sessions keep full access.
    const isLegacySession = credentials?.token && !credentials?.user;
    const user = credentials.user ||
      (isLegacySession
        ? {
            username: credentials.auth?.username || "",
            fullName: credentials.auth?.username || "",
            roleName: "مدير عام",
            isSuperAdmin: true,
          }
        : null);
    const permissions = credentials.permissions || (isLegacySession ? "all" : null);
    await dispatch(
      saveDataLocalStorage({
        token: credentials.token,
        auth: credentials.auth,
        user,
        permissions,
      })
    );
    await dispatch(fetchData());
  } catch (error) {
    toast.error("هناك خطا ما في اسم المستخدم او الباسورد");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolStatusAction =
  ({ rgmw, status }) =>
    async (dispatch) => {
      try {
        await dispatch(updateSchoolStatus({ rgmw, status }));
      } catch (error) {
        toast.error("هناك خطأ ما ");
        dispatch(loginFailure(error.message));
      }
    };

export const changeSchoolClosedAction = (rgmw) => async (dispatch) => {
  try {
    await dispatch(changeSchoolClosed(rgmw));
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolPayDateAction =
  ({ rgmw, date }) =>
    async (dispatch) => {
      try {
        await dispatch(updateSchoolPayDate({ rgmw, date }));
      } catch (error) {
        toast.error("هناك خطأ ما");
        dispatch(loginFailure(error.message));
      }
    };

export const SeenNoteAction = (id) => async (dispatch) => {
  try {
    await dispatch(SeenNote(id));
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const deleteExpenseAction = (id) => async (dispatch) => {
  try {
    return await dispatch(deleteExpense(id));
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const MakeNoteAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(MakeNote(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolPhoneNumberAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolPhoneNumber(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolPSEditPinAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolPSEditPin(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolAnydeskIdAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolAnydeskId(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolNameAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolName(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolApiGroupAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolApiGroup(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const AddSchoolAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(AddSchool(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطا ما");
    dispatch(loginFailure(error.message));
  }
};

export const AddFinancialAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(AddFinancial(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolPriceAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolPrice(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const updateSchoolPaymentTypeAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(updateSchoolPaymentType(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const AddExpenseAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(AddExpense(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const editVersionAction = (data) => async (dispatch) => {
  try {
    const result = await dispatch(editVersion(data));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    return { error: true, message: error.message };
  }
};

export const changeStatusSchoolAction = (rgmw) => async (dispatch) => {
  try {
    const result = await dispatch(changeStatusSchool(rgmw));
    await dispatch(fetchData(true));
    return result;
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

// Add new actions for close_malia, close_employee, close_students, and close_modeer
export const updateCloseMaliaAction = createAsyncThunk(
  "main/updateCloseMalia",
  async ({ rgmw, status }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-close-malia/${token}/`,
        { rgmw, status }
      );
      // toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCloseEmployeeAction = createAsyncThunk(
  "main/updateCloseEmployee",
  async ({ rgmw, status }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-close-employee/${token}/`,
        { rgmw, status }
      );
      // toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCloseStudentsAction = createAsyncThunk(
  "main/updateCloseStudents",
  async ({ rgmw, status }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-close-students/${token}/`,
        { rgmw, status }
      );
      // toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCloseModeerAction = createAsyncThunk(
  "main/updateCloseModeer",
  async ({ rgmw, status }, { getState, rejectWithValue }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/update-close-modeer/${token}/`,
        { rgmw, status }
      );
      //toast.success(response.data.message);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



// Add these new actions for WhatsNew operations

export const addWhatsNew = createAsyncThunk(
  "main/addWhatsNew",
  async (data, { getState, rejectWithValue, dispatch }) => {
    try {
      const token = getState().main.token;
      const response = await request.post(
        `/api/alfares/whatsnewtbl/${token}`,
        { VerNumber: data.VerNumber, Newnotes: data.Newnotes },
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("تم إضافة الملاحظة بنجاح");
      dispatch(fetchData(true));
      return response.data;
    } catch (error) {
      toast.error("حدث خطأ أثناء إضافة الملاحظة");
      return rejectWithValue(error.message);
    }
  }
);

export const editWhatsNew = createAsyncThunk(
  "main/editWhatsNew",
  async (data, { getState, rejectWithValue, dispatch }) => {
    try {
      const token = getState().main.token;
      const response = await request.put(
        `/api/alfares/whatsnewtbl/${data.id}/${token}`,
        { VerNumber: data.VerNumber, Newnotes: data.Newnotes },
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("تم تحديث الملاحظة بنجاح");
      dispatch(fetchData(true));
      return response.data;
    } catch (error) {
      toast.error("حدث خطأ أثناء تحديث الملاحظة");
      return rejectWithValue(error.message);
    }
  }
);

export const deleteWhatsNew = createAsyncThunk(
  "main/deleteWhatsNew",
  async (id, { getState, rejectWithValue, dispatch }) => {
    try {
      const token = getState().main.token;
      const response = await request.delete(
        `/api/alfares/whatsnewtbl/${id}/${token}`
      );
      dispatch(fetchData(true));
      return response.data;
    } catch (error) {
      toast.error("فشل في حذف البنود");
      return rejectWithValue(error.message);
    }
  }
);

// Add these action creators
export const addWhatsNewAction = (data) => async (dispatch) => {
  try {
    await dispatch(addWhatsNew(data));
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const editWhatsNewAction = (data) => async (dispatch) => {
  try {
    await dispatch(editWhatsNew(data));
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

export const deleteWhatsNewAction = (id) => async (dispatch) => {
  try {
    await dispatch(deleteWhatsNew(id));
  } catch (error) {
    toast.error("هناك خطأ ما");
    dispatch(loginFailure(error.message));
  }
};

// Notification actions
export const addNotification = createAsyncThunk(
  "main/addNotification",
  async (data, { getState, rejectWithValue, dispatch }) => {
    try {
      let token = getState().main.token;
      if (!token) {
        const credentials = JSON.parse(localStorage.getItem("userCredentials"));
        token = credentials?.token;
      }
      const response = await axios.post(
        `https://api.alfares.cloud/api/alfares/notifications/${token}`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("تم إضافة التنبيه بنجاح");
      dispatch(fetchData(true));
      return response.data;
    } catch (error) {
      toast.error("حدث خطأ أثناء إضافة التنبيه");
      return rejectWithValue(error.message);
    }
  }
);

export const editNotification = createAsyncThunk(
  "main/editNotification",
  async (data, { getState, rejectWithValue, dispatch }) => {
    try {
      let token = getState().main.token;
      if (!token) {
        const credentials = JSON.parse(localStorage.getItem("userCredentials"));
        token = credentials?.token;
      }
      const response = await axios.put(
        `https://api.alfares.cloud/api/alfares/notifications/${data.id}/${token}`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("تم تحديث التنبيه بنجاح");
      dispatch(fetchData(true));
      return response.data;
    } catch (error) {
      toast.error("حدث خطأ أثناء تحديث التنبيه");
      return rejectWithValue(error.message);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  "main/deleteNotification",
  async (id, { getState, rejectWithValue, dispatch }) => {
    try {
      let token = getState().main.token;
      if (!token) {
        const credentials = JSON.parse(localStorage.getItem("userCredentials"));
        token = credentials?.token;
      }
      const response = await axios.delete(
        `https://api.alfares.cloud/api/alfares/notifications/${id}/${token}`
      );
      toast.success("تم حذف التنبيه بنجاح");
      dispatch(fetchData(true));
      return response.data;
    } catch (error) {
      toast.error("فشل في حذف التنبيه");
      return rejectWithValue(error.message);
    }
  }
);

export const addNotificationAction = (data) => async (dispatch) => {
  try {
    await dispatch(addNotification(data));
  } catch (error) {
    dispatch(loginFailure(error.message));
  }
};

export const editNotificationAction = (data) => async (dispatch) => {
  try {
    await dispatch(editNotification(data));
  } catch (error) {
    dispatch(loginFailure(error.message));
  }
};

export const deleteNotificationAction = (id) => async (dispatch) => {
  try {
    await dispatch(deleteNotification(id));
  } catch (error) {
    dispatch(loginFailure(error.message));
  }
};

export default mainSlice.reducer;
